import React, { Component } from 'react';
import { Col, FormGroup, Button } from "react-bootstrap";
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';
import { savePayment } from "../../../../redux/actions/action_postEvent";
import { style, blue, warning, gray, green } from '../../../../utils/constants';
import { onlypositivenumbers } from '../../../../utils/functions';

const sectionBorder = {
  border: `1px solid ${gray}`,
  padding: '15px',
  marginRight: '0px',
  marginBottom: '15px'
};

const FormName = 'postevent';
class FeesPayment extends Component {
  constructor(props) {
    super(props);
    this.handleNotToExceedLength = this.handleNotToExceedLength.bind(this);
    this.handleMakePayment = this.handleMakePayment.bind(this);
    this.generateUpdateErrors = this.generateUpdateErrors.bind(this);
  }
  handleMakePayment() {
    const {
      eventId,
      ccnumber,
      nameoncard,
      expiration,
      paymentDue,
      cvc,
      eventname,
      savingPayment
    } = this.props;

    const deposit = {
      nameOnCard: nameoncard,
      cardExpiration: expiration,
      ccNumber: ccnumber,
      amount: Math.abs(paymentDue),
      cvc: cvc,
      eventname: eventname
    };

    if (!savingPayment) {
      this.props.dispatch(savePayment(eventId, deposit));
    }
  }

  handleNotToExceedLength(evt) {
    const { value, maxLength } = evt.target;
    if ((value.length > maxLength)) {
      return evt.target.value = value.substring(0, maxLength);
    }
  }
  generateUpdateErrors(errors) {
    const error = errors.map((key, index) => {
      return (<li key={index} style={{ color: warning }}>{this.props.updatePaymentErrors[key]}</li>)
    })
    return error;
  }

  render() {

    const {
      handleSubmit,
      eventname,
      ccnumber,
      nameoncard,
      expiration,
      cvc,
      paymentDue,
      paymentDate,
      paymentConfirmation,
      savingPayment,
      updatePaymentErrors,
      paymentAmount
    } = this.props;

    const feeamount = Math.abs(paymentDue);

    const feesPaymentErrors = Object.keys(updatePaymentErrors);

    const depositPaid = (paymentDate !== null && paymentDate !== undefined && paymentDate !== '');
    return (
      <div style={{ marginTop: '1%' }} sm={5}>
        <form onSubmit={handleSubmit} className="form-horizontal">
          {
            feesPaymentErrors.length > 0 &&
            (<Col sm={12} style={sectionBorder}>
              <h4 style={{ color: warning }}>* Please correct the following errors to proceed:</h4>
              <ul>
                {
                  this.generateUpdateErrors(feesPaymentErrors)
                }
              </ul>
            </Col>)
          }
          {
            depositPaid &&
            (<div><span style={{ paddingLeft: '15px', color: blue, fontSize: '16px' }}>
              <p className="fa fa-info-circle" />&nbsp;&nbsp;Payment received on {paymentDate} for the amount of ${paymentAmount}, confirmation number {paymentConfirmation}.
			</span></div>)
          }
          {depositPaid &&
            (<div><span style={{ paddingLeft: '15px', color: green, fontSize: '16px' }}>
              <p className="fa fa-check" />&nbsp;&nbsp;Post Management is complete. Click previous to go back, navigate using the menu or log out to close the app.
			</span></div>)}
          {
            !depositPaid && (
              <Col md={9} style={{ border: `1px solid ${gray}`, padding: '15px', marginRight: '0px', marginBottom: '15px' }} >
                <FormGroup style={{ padding: '0 0 15px 25px', margin: '0' }}>
                  <h4 className='text-left' style={{ color: blue }}>{' '}Event Name - {eventname}</h4>
                  <h5 style={{ color: warning }} />
                </FormGroup>
                <div className='col-sm-6'>
                  <FormGroup sm={5}>
                    <label className={style.lblattrs4}>Name on card &nbsp;</label>
                    <Field
                      type='string'
                      name='nameoncard'
                      component='input'
                      className="form-control"
                      style={{ maxWidth: '180px' }}
                    />
                  </FormGroup>
                  <FormGroup sm={5}>
                    <label className={style.lblattrs4}>CC Number &nbsp;</label>
                    <Field
                      type='number'
                      name='ccnumber'
                      component='input'
                      onKeyDown={onlypositivenumbers}
                      onKeyUp={this.handleNotToExceedLength}
                      className="form-control no-spinners"
                      style={{ maxWidth: '180px' }}
                      maxLength='16'
                      placeholder='#### #### #### ####'
                    />
                  </FormGroup>
                  <FormGroup sm={5}>
                    <label className={style.lblattrs4}>Expiration &nbsp;</label>
                    <Field
                      type='number'
                      name='expiration'
                      component='input'
                      className="form-control no-spinners"
                      placeholder='mmyy'
                      maxLength='4'
                      onKeyUp={this.handleNotToExceedLength}
                      style={{ maxWidth: '180px' }}
                    />
                  </FormGroup>
                  <FormGroup sm={5}>
                    <label className={style.lblattrs4}>CVC &nbsp;</label>
                    <Field
                      type='number'
                      name='cvc'
                      component='input'
                      className="form-control no-spinners"
                      maxLength='3'
                      onKeyUp={this.handleNotToExceedLength}
                      style={{ maxWidth: '180px' }}
                      placeholder='###'
                    />
                  </FormGroup>
                  <FormGroup sm={5}>
                    <label className={style.lblattrs4}>Fee Amount &nbsp;$</label>
                    <input type='text' disabled='true' className="form-control" style={{ maxWidth: '180px' }} value={feeamount} />
                  </FormGroup>
                  <FormGroup sm={4}>
                    <Button className='btn btn-success' style={{ marginLeft: '33%' }} onClick={this.handleMakePayment} >
                      <i className={savingPayment === true ? "fa fa-spinner fa-spin" : "fa fa-credit-card"} aria-hidden="true" />&nbsp;&nbsp;Make Payment
						</Button>
                  </FormGroup>
                </div>
                <div className='col-sm-4' style={{ marginLeft: '-50px', marginTop: '8px' }}>
                  <FormGroup md={3}>
                    <Cards
                      number={ccnumber}
                      name={nameoncard}
                      expiry={expiration}
                      cvc={cvc}
                      focused='name'
                    />
                  </FormGroup>
                </div>
              </Col>
            )
          }
        </form>
      </div>)
  }
}

FeesPayment.propTypes = {
  handleSubmit: PropTypes.func,
  dispatch: PropTypes.func,
  eventId: PropTypes.number,
  eventname: PropTypes.string,
  nameoncard: PropTypes.string,
  ccnumber: PropTypes.string,
  expiration: PropTypes.string,
  cvc: PropTypes.string,
  paymentDue: PropTypes.number,
  paymentDate: PropTypes.string,
  paymentConfirmation: PropTypes.string,
  paymentAmount: PropTypes.number,
  savingPayment: PropTypes.bool,
  updatePaymentErrors: PropTypes.object
}

function mapStateToProps(state, ownProps) {
  const formName = ownProps.form
  const selector = formValueSelector(formName)
  const eventId = selector(state, 'eventId')
  const eventname = selector(state, 'eventname')
  const nameoncard = selector(state, 'nameoncard')
  const ccnumber = selector(state, 'ccnumber')
  const expiration = selector(state, 'expiration')
  const cvc = selector(state, 'cvc')
  const paymentDate = selector(state, 'paymentDate')
  const savingPayment = selector(state, 'savingPayment');
  const paymentConfirmation = selector(state, 'paymentConfirmation');
  const paymentAmount = selector(state, 'paymentAmount');
  const updatePaymentErrors = selector(state, 'updatePaymentErrors');
  return {
    eventId,
    eventname,
    nameoncard,
    ccnumber,
    expiration,
    cvc,
    paymentDate,
    paymentConfirmation,
    savingPayment,
    paymentAmount,
    updatePaymentErrors
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    savePayment
  }, dispatch);
}
export default reduxForm({
  form: FormName,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false
})(connect(mapStateToProps, mapDispatchToProps)(FeesPayment))



// WEBPACK FOOTER //
// ./src/containers/postevent/components/fees/payment.js